import { render, staticRenderFns } from "./AffiliateDashboardTable.vue?vue&type=template&id=2d65f07d&scoped=true&"
import script from "./AffiliateDashboardTable.vue?vue&type=script&lang=js&"
export * from "./AffiliateDashboardTable.vue?vue&type=script&lang=js&"
import style0 from "./AffiliateDashboardTable.vue?vue&type=style&index=0&id=2d65f07d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d65f07d",
  null
  
)

export default component.exports